import { Campionato } from "../types/campionati/campionato";
import { CampionatoRanking } from "../types/campionati/campionatoRanking";
import { ApiService } from "./apiService";
import { ENDPOINTS } from "../config/apiConfig";

export class CampionatiService {
  static async getCampionatiList(
    pageNumber = 1,
    pageSize = 10,
    name?: string,
    discipline?: number
  ): Promise<any> {
    let query = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (discipline) query += `&discipline=${discipline}`;
    if (name) {
      query += `&search=${encodeURIComponent(name)}`;
    }
    return ApiService.client.get<any>(ENDPOINTS.LEAGUES.LIST + query);
  }

  static async getCampionatoById(id: number): Promise<Campionato> {
    return ApiService.client.get<Campionato>(ENDPOINTS.LEAGUES.GET_BY_ID(id));
  }

  static async createCampionato(
    campionato: Omit<Campionato, "id">
  ): Promise<Campionato> {
    return ApiService.client.post<Campionato>(
      ENDPOINTS.LEAGUES.CREATE,
      campionato
    );
  }

  static async updateCampionato(
    id: number,
    campionato: Partial<Campionato>
  ): Promise<Campionato> {
    return ApiService.client.put<Campionato>(
      ENDPOINTS.LEAGUES.UPDATE(id),
      campionato
    );
  }

  static async deleteCampionato(id: number): Promise<void> {
    await ApiService.client.delete<void>(ENDPOINTS.LEAGUES.DELETE(id));
  }

  static async getCampionatoRanking(leagueId: number): Promise<CampionatoRanking> {
    return ApiService.client.get<CampionatoRanking>(ENDPOINTS.LEAGUES.RANKING(leagueId));
  }
}
